






































































































import {Component, Vue, Prop,Watch} from 'vue-property-decorator'
import kepler from "@/../lib/kepler_sdk/kepler";
import ACard from "@/components/UI/ACard.vue";
import NMapMarker from "../../../lib/n-maps/NMapMarker.vue";
import ACardPlus from "@/components/UI/ACardPlus.vue";

@Component({
  components: {ACardPlus, NMapMarker, ACard},
})
export default class Bookings extends Vue {
  @Prop() id!:string
  public bookingId:any = ''
  public loadValue = 0

  public reservation = null
  public vehicle = null
  public bookedTimes = null
  public debugInfo = null
  public route = null

  private getTimelineItemConfig(logItem: any) {
    let isSystem = logItem.user.startsWith("U") || logItem.user.startsWith("S")
    if (isSystem) {
      return {}
    } else {
      return {
        'fill-dot': true
      }
    }
  }
  @Watch('id')
  public getBookingIdProp() {
    if(this.id) {
      this.bookingId = this.id
    } else {
      this.bookingId = this.$route.params.id
    }
    this.dataLoad()
  }
  public mounted() {
    this.getBookingIdProp()

  }

  public getColor(status: any) {
    switch (status) {
      case 'ACTIVE':
        return 'accent'
      case 'SUSPENDED':
        return 'error'
      default:
        return 'warning'
    }
  }

  public getVehicleStatusColor(status: any) {
    switch (status) {
      case 'LOCKED':
        return 'error'
      case 'UNLOCKED':
        return 'accent'
      case 'NOT RUNNING':
        return 'error'
      case 'RUNNING':
        return 'accent'
      default:
        return 'warning'
    }
  }

  public formatDate(date: any) {
    let d = new Date(date)
    return `${d.getDate().toString().padStart(2, "0")}-${d.getMonth().toString().padStart(2, "0")}-${d.getFullYear().toString()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
  }

  public openVehicleDetail(vehicleId: any) {

    this.$router.push({name: 'vehicle', params: {id: vehicleId}})
  }

  private dataLoad() {
    this.loadValue = 1
    kepler.getSingle('reservation', this.bookingId)!.then((d) => {
      this.reservation = d.data
      this.vehicle = d.data.vehicle
      this.loadValue = 25
      // kepler.getSingle('reservation_booked_times', this.$route.params.id)!.then((d) => {
      //   this.bookedTimes = d.data
      //   this.loadValue = 50
        kepler.getSingle('reservation_debug_info',  this.bookingId)!.then((d) => {
          this.debugInfo = d.data
          this.loadValue = 75
          kepler.getSingle('reservation_route',  this.bookingId)!.then((d) => {
            this.route = d.data
            this.loadValue = 100
          })
        })
    //  })
    })
  }
}
